import React, { useState } from "react";
import Helmet from "react-helmet";
import { AppName } from "../../../../util/app";
import DatePicker from "react-datepicker";
import Select from "react-dropdown-select";
import data from "./data.json";
import chart from "./bristol-stool-chart.jpg";
import { toast } from "react-toastify";
import TransOptions from "./trans.json";

const NewObservation = ({ onCancel, onSubmit }) => {
    const [model, setModel] = useState({
        date: new Date(),
        nextDate: new Date(),
        rationale: "",
        consent: "",
        observation: {
            height: "",
            weight: "",
            bmi: "",
            more: [],
        },
        glasgow: {},
        tranquilization: {
            taken: "",
            selected: [],
        },
        qRisk: {},
        smoke: {},
    });

    const calBMI = () => {
        if (model.observation.height && model.observation.weight) {
            const _model = { ...model };
            const m2 = Math.pow(_model.observation.height / 100, 2);
            const r = _model.observation.weight / m2;
            _model.observation.bmi = r.toFixed(1);
            setModel(_model);
        } else {
            toast.warn("Height and weight are required!");
        }
    };

    const AddMore = (key, value) => {
        let found = false;
        const _model = { ...model };
        if (key && value) {
            for (let index = 0; index < _model.observation.more.length; index++) {
                if (_model.observation.more[index].key === key) {
                    found = true;
                    _model.observation.more[index].value = value;
                }
            }

            if (!found) {
                _model.observation.more.push({ key, value });
            }
        }
        setModel(_model);
    };

    const selectTransq = (value) => {
        let found = false;
        const _model = { ...model };
        for (let index = 0; index < _model.tranquilization.selected.length; index++) {
            if (_model.tranquilization.selected[index] === value) {
                found = true;
                _model.tranquilization.selected.splice(index, 1);
            }
        }
        if (!found) _model.tranquilization.selected.push(value);

        setModel(_model);
    };

    return (
        <>
            <Helmet>
                <title> New Health Observation | {AppName}</title>
            </Helmet>

            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    onSubmit(model);
                }}
            >
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Administration</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong className="text-primary">Date of Observation</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <DatePicker
                                            selected={model.date}
                                            onChange={(date) => setModel({ ...model, date })}
                                            className="form-control input-height"
                                            timeIntervals={5}
                                            showTimeSelect
                                            timeCaption="Time"
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong className="text-primary">Date Next Due</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <DatePicker
                                            selected={model.nextDate}
                                            onChange={(date) => setModel({ ...model, nextDate: date })}
                                            className="form-control input-height"
                                            timeIntervals={5}
                                            showTimeSelect
                                            timeCaption="Time"
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Rationale</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <Select
                                            options={[{ value: "Routine" }, { value: "Physical Health Deterioration" }, { value: "Random" }]}
                                            valueField="value"
                                            labelField="value"
                                            onChange={(items) => setModel({ ...model, rationale: items[0].value })}
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Consent</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <Select
                                            onChange={(items) => setModel({ ...model, consent: items[0].value })}
                                            options={[{ value: "Yes" }, { value: "No" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Observation</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "5%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>Height (cm)*</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-md-8">
                                        <input
                                            type="number"
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    observation: {
                                                        ...model.observation,
                                                        height: currentTarget.value,
                                                    },
                                                })
                                            }
                                            className="form-control input-height"
                                            min="0"
                                            id="height-id"
                                            required
                                            aria-describedby="height-id"
                                        />
                                    </div>
                                </td>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>Click to load your previous Height</td>
                                <td>
                                    <button type="button" className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-primary">
                                        Click Me
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "5%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>Weight (kg)*</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-md-8">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    observation: {
                                                        ...model.observation,
                                                        weight: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="number"
                                            className="form-control input-height"
                                            min="0"
                                            id="weight-id"
                                            required
                                            aria-describedby="weight-id"
                                        />
                                    </div>
                                </td>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>Click to calculate BMI</td>
                                <td>
                                    <button type="button" onClick={calBMI} className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-primary">
                                        Click Me
                                    </button>
                                </td>
                            </tr>

                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "5%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>BMI</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-md-8">
                                        <input
                                            type="text"
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    observation: {
                                                        ...model.observation,
                                                        bmi: currentTarget.value,
                                                    },
                                                })
                                            }
                                            defaultValue={model.observation.bmi}
                                            className="form-control input-height"
                                            id="bmi-id"
                                            required
                                            aria-describedby="bmi-id"
                                        />
                                    </div>
                                </td>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>BMI category</td>
                                <td></td>
                            </tr>
                            {data.map((item, idx) => (
                                <tr key={idx}>
                                    <td style={{ backgroundColor: "aliceblue", width: "5%" }}>
                                        <strong>{item.initial}</strong>
                                    </td>
                                    <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                        <strong>{item.item}</strong>
                                    </td>
                                    <td style={{ width: "40%" }}>
                                        <div className="col-md-8">
                                            {item.options.length > 0 ? (
                                                <Select
                                                    onChange={(items) => AddMore(item.initial + item.item, items[0].value)}
                                                    options={item.options}
                                                    valueField="value"
                                                    labelField="label"
                                                    separator
                                                    placeholder="-- Please Select --"
                                                />
                                            ) : (
                                                <input
                                                    onChange={({ currentTarget }) => AddMore(item.initial + " " + item.item, currentTarget.value)}
                                                    type="text"
                                                    className="form-control input-height"
                                                    min="0"
                                                    id={item.item}
                                                    required
                                                    aria-describedby="bmi-id"
                                                />
                                            )}
                                        </div>
                                    </td>
                                    <td style={{ backgroundColor: "aliceblue", width: "15%" }}>{item.hint}</td>
                                    <td></td>
                                </tr>
                            ))}
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "5%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>Evidence of EPSE's</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-md-8">
                                        <Select
                                            options={[
                                                { value: "Yes", label: "Yes" },
                                                { value: "No", label: "No" },
                                                { value: "Don't Know", label: "Don't Know" },
                                            ]}
                                            onChange={(items) => AddMore("Evidence of EPSE's", items[0].value)}
                                            valueField="value"
                                            labelField="label"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>Details</td>
                                <td>
                                    <input
                                        onChange={({ currentTarget }) => AddMore("Details", currentTarget.value)}
                                        type="text"
                                        className="form-control"
                                        id="Evidence"
                                        name="Evidence"
                                        required
                                        aria-describedby="Evidence-id"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "5%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>Bristol Stool Chart Score</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-md-8">
                                        <Select
                                            onChange={(items) => AddMore("Bristol Stool Chart Score", items[0].value)}
                                            options={[
                                                { value: "Type 1 - Separate hard lumps (Very constipated)", label: "Type 1" },
                                                { value: "Type 2 - Lumpy and sausage-like (Slightly constipated)", label: "Type 2" },
                                                { value: "Type 3 - A sausage shape with cracks in the surface (Normal)", label: "Type 3" },
                                                { value: "Type 4 - Like a smooth, soft sausage or snake (Normal)", label: "Type 4" },
                                                { value: "Type 5 - Soft blobs with clear-cut edges (Lacking fiber)", label: "Type 5" },
                                                { value: "Type 6 - Mushy consistency with ragged edges (inflammation)", label: "Type 6" },
                                                { value: "Type 7 - Liquid consistency with no solid pieces (inflammation and diarrhea)", label: "Type 7" },
                                            ]}
                                            valueField="value"
                                            labelField="label"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td colSpan="2">
                                    <button data-toggle="modal" data-target="#exampleModal" type="button" className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-primary">
                                        Bristol Stool Chart
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "5%" }}></td>
                                <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                    <strong>Total NEWS 2 Score</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-md-8"></div>
                                </td>
                                <td style={{ backgroundColor: "aliceblue", width: "15%" }}>Total NEWS 2 Score (BP Standing)</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Glasgow Coma Scale</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Best Eye Response</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-8">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    glasgow: {
                                                        ...model.glasgow,
                                                        eye: items[0].value,
                                                    },
                                                })
                                            }
                                            options={[{ value: "Eye opened Spontaneously" }, { value: "Eye Opening to Pain" }, { value: "Eye Opening Verbal Stimuli" }, { value: "No Eye Opening" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Best Verbal Response</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-8">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    glasgow: {
                                                        ...model.glasgow,
                                                        verbal: items[0].value,
                                                    },
                                                })
                                            }
                                            options={[{ value: "Confused" }, { value: "Inappropriate" }, { value: "Incomprehensible Words" }, { value: "No Verbal Response" }, { value: "Orientated" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Best Motor Response</strong>
                                </td>
                                <td style={{ width: "40%" }}>
                                    <div className="col-8">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    glasgow: {
                                                        ...model.glasgow,
                                                        motor: items[0].value,
                                                    },
                                                })
                                            }
                                            options={[
                                                { value: "Abnormal Extension to Pain" },
                                                { value: "Abnormal Flexion to Pain" },
                                                { value: "Localising Pain" },
                                                { value: "No Motor Response" },
                                                { value: "Obeys Commands" },
                                                { value: "Withdraw from pain" },
                                            ]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Rapid Tranquilisation</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Please select when obs taken</strong>
                                </td>
                                <td>
                                    <div className="col-8">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    tranquilization: {
                                                        ...model.tranquilization,
                                                        taken: items[0].value,
                                                    },
                                                })
                                            }
                                            options={[{ value: "Pre Rapid Tranquilisation" }, { value: "Post Rapid Tranquilisation" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" className="text-center" style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Tick Symptoms recorded</strong>
                                </td>
                            </tr>
                            {TransOptions.map((opt, idx) => (
                                <tr key={idx}>
                                    <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                        <strong>{opt}</strong>
                                    </td>
                                    <td>
                                        <div class="custom-control custom-checkbox">
                                            <input onChange={() => selectTransq(opt)} type="checkbox" class="custom-control-input" id={opt} />
                                            <label class="custom-control-label" htmlFor={opt}>
                                                Tick
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>QRisk3</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>QRisk3 Score</strong>
                                </td>
                                <td>
                                    <div className="col-md-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    qRisk: {
                                                        ...model.qRisk,
                                                        score: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            id="QRisk3-id"
                                            required
                                            aria-describedby="QRisk3-id"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Has a Medication Reconciliation been undertaken?</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    qRisk: {
                                                        ...model.qRisk,
                                                        taken: items[0].value,
                                                    },
                                                })
                                            }
                                            options={[{ value: "Yes" }, { value: "No" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Comments on Medication Reconciliation</strong>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <textarea
                                        onChange={({ currentTarget }) =>
                                            setModel({
                                                ...model,
                                                qRisk: {
                                                    ...model.qRisk,
                                                    comment: currentTarget.value,
                                                },
                                            })
                                        }
                                        name="comment-id"
                                        id="comment-id"
                                        className="form-control form-control-textarea"
                                        required
                                        rows="2"
                                        placeholder="enter contact comment"
                                    ></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Smoking</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Smoking Status</strong>
                                </td>
                                <td>
                                    <div className="col-md-6">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    smoke: {
                                                        ...model.smoke,
                                                        status: items[0].value,
                                                    },
                                                })
                                            }
                                            options={[{ value: "Regular Smoker" }, { value: "Occasional Smoker" }, { value: "Ex Smoker" }, { value: "None Smoker" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Number of Cigarette a day</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    smoke: {
                                                        ...model.smoke,
                                                        noCigaret: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="number"
                                            name="Cigarette_name"
                                            id="Cigarette_name"
                                            className="form-control input-height"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>Has Patient been offered Smoking Cessation?</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <Select
                                            onChange={(items) =>
                                                setModel({
                                                    ...model,
                                                    smoke: {
                                                        ...model.smoke,
                                                        offeredCessation: items[0].value,
                                                    },
                                                })
                                            }
                                            options={[{ value: "Yes" }, { value: "No" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>If yes, what was the outcome?</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    smoke: {
                                                        ...model.smoke,
                                                        outcome: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            name="outcome"
                                            id="outcome"
                                            placeholder="enter outcome"
                                            className="form-control input-height"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "25%" }}>
                                    <strong>If No, reason</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    smoke: {
                                                        ...model.smoke,
                                                        reasonForNo: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            name="reason_smoke"
                                            id="reason_smoke"
                                            placeholder="enter reason"
                                            className="form-control input-height"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="col-12 text-center mt-5 mb-5">
                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  margin-right-10 btn-circle btn-success">
                        Submit
                        <i className="material-icons">arrow_right_alt</i>
                    </button>

                    <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-default">
                        <i className="material-icons text-danger">cancel</i> Cancel
                    </button>
                </div>
            </form>

            <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Bristol Stool Chart
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <img src={chart} alt="Bristol Stool Chart" width="440px" />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewObservation;
